import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";
import { SvgYearInReviewTextFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewTextFull";

export const YearInReviewGeneratingPage = ({}) => {
  return (
    <div className="flex flex-col items-center gap-[60px]">
      <div className="flex space-x-[19px] justify-center">
        <Icon icon={<SvgYearInReviewLogoFull />} className="w-[104.273px] h-[100px]" />
        <div className="flex flex-col space-y-[20px]">
          <Icon icon={<SvgYearInReviewTextFull />} className="w-[156.779px] h-[76.266px] " />
          <div className="w-[154.933px] h-[3.35px] bg-[#D3A752] drop-shadow-[0_2px_2px_rgba(0,0,0,0.25)]  border-0" />
        </div>
      </div>
      <h1 className="text-center text-[48px] font-medium uppercase leading-normal tracking-normal drop-shadow-[0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow] bg-gradient-to-b from-[#F4C874_25%] to-[#D3A752_84%] bg-clip-text text-transparent">
        WE'RE CREATING YOUR
        <br />
        YEAR IN REVIEW
      </h1>
      <p className="text-center font-inter text-[18px] font-normal leading-normal text-white">
        Hang tight, this might take a moment.
      </p>
      <div className="relative h-[4px] w-[600px] overflow-hidden rounded-[2px] bg-[#070720]">
        <div className="absolute left-0 top-0 h-full w-1/4 animate-shimmer rounded-[2px] bg-[#F4C874]"></div>
      </div>
      <p className="text-center text-sm font-normal leading-normal text-[#CDDCFE] font-inter">
        Generating your Year in Review pulls data exclusively from your public League of Legends
        <br /> match history to create personalized stats, highlights, and achievements.
        <br />
        <br />
        Only publicly available information will be accessed, ensuring your privacy is protected.
      </p>
    </div>
  );
};
